export const toTitleCase = (value) => value[0]?.toUpperCase() + value?.slice(1);
export const AUTH_TOKEN = "token";

export const getNameInitials = (str) => {
  if (typeof str !== "string") {
    return "";
  }
  let words = str.split(" ");
  let initials = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
  return initials;
};

export const convertToDateString = (value) => {
  const dateTimeArray = value?.split("_");
  const date = dateTimeArray[0];
  const time = dateTimeArray[1];
  const dateArray = date?.split("-");
  return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}, ${time?.split("-").join(":")}`;
};

export const findViolationItems = (data) => {
  const items = [];
  for (const accessory in data) {
    data[accessory].forEach((detail) => {
      if (detail.confidence < 0) {
        if (!items?.includes(accessory?.toLowerCase())) {
          items.push(accessory?.toLowerCase());
        }
      }
    });
  }
  return items;
};
